import { useMediaQuery } from '@mui/material'
import { useCustomTheme } from '../context/ThemeContext'

export const useResponsiveTypography = () => {
  const { theme } = useCustomTheme()
  const isXs = useMediaQuery(theme.breakpoints.only('xs'))
  const isSm = useMediaQuery(theme.breakpoints.only('sm'))
  const isMd = useMediaQuery(theme.breakpoints.only('md'))
  const isLg = useMediaQuery(theme.breakpoints.only('lg'))
  const isXl = useMediaQuery(theme.breakpoints.only('xl'))

  const cardIcons = {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    flexDirection: isXs || isSm ? 'column' : 'row',
  }

  const loginButton = {
    display: 'flex',
    alignItems: 'center',

    gap: isXs || isSm ? '0.5px' : '0px',
    flexDirection: isXs || isSm ? 'column' : 'row',
  }

  const goButton = {
    display: 'flex',
    gap: isXs || isSm ? '0.2px' : '0px',
    flexDirection: isXs || isSm ? 'column' : 'row',
  }

  const chipText = {
    fontSize: isXs || isSm ? '10px' : '13px',
    padding: isXs || isSm ? '4px 4px' : '6px 6px',
  }
  const dataEntryPageTittle = {
    margin: '10px 0px',
    fontSize: isXs || isSm ? '12px' : '30px',
    fontWeight: 'bold',
  }
  const dataEntryPageHeading = {
    fontSize: isXs || isSm ? '18px' : '36px',
  }
  const headingStyles = {
    margin: isXs || isSm ? '3px 0px' : '10px 0px',
    fontSize: isXs ? '16px' : isSm ? '18px' : isMd ? '20px' : isLg ? '22px' : '24px',
  }
  const paragraphStyles = {
    margin: isXs || isSm ? '3px 0px' : '4px 0px',
    fontSize: isXs ? '12px' : isSm ? '12px' : isMd ? '14px' : isLg ? '16px' : '18px',
  }
  const tableContainerStyles = {
    maxHeight: '75vh',
    border: '0.2px solid rgba(224, 224, 224, 1)',
    boxSizing: 'border-box',
  }

  const getTypographyVariant = () => {
    if (isXs) return 'h8'
    if (isSm) return 'h8'
    if (isMd) return 'h5'
    if (isLg) return 'h5'
    if (isXl) return 'h5'
    return 'h5' // default variant
  }

  const getResponsiveTypography = () => {
    if (isXs) {
      return {
        title: '12px',
        subtitle: '12px',
        body: '1rem',
        cardIcons,
        loginButton,
        chip: chipText,
        dataEntryPageTittle,
        dashboardTittle: '12px',
        dashboardSubTittle: '12px',
        goButton,
        headingStyles,
        paragraphStyles,
        previewHeading: '16px',
        cardtitle: '11px',
        cardSubtitle: '10px',
        datetitle: '10px',
        heading: '12px',
        subheading: '10px',
        timelinetitle: '12px',
        timelinetitlesubtitle: '10px',
        modelheading: '14px',
        admintitle: '14px',
        adminsubtitle: '12px',
        admincardtitle: '10px',
        typographyVariant: getTypographyVariant(),
        previewSubHeading: '10px',
        previewPageFont: '10px',
        previewText: '8px',
        tableContainerStyles,
        tablePreviewHeaderFont: '10px',
        menutitle: '12px',
        dataEntryPageTitle: '13px',
        dataEntrysubtitle: '12px',
      }
    }
    if (isSm) {
      return {
        heading: '14px',
        subheading: '12px',
        title: '12px',
        subtitle: '12px',
        body: '1.125rem',
        cardIcons,
        loginButton,
        chip: chipText,
        dataEntryPageTittle,
        datetitle: '10px',
        cardtitle: '10px',
        cardSubtitle: '9px',
        dashboardTittle: '13px',
        dashboardSubTittle: '12px',
        admintitle: '14px',
        adminsubtitle: '12px',
        goButton,
        headingStyles,
        paragraphStyles,
        previewHeading: '16px',
        typographyVariant: getTypographyVariant(),
        previewSubHeading: '10px',
        previewPageFont: '10px',
        previewText: '8px',
        tableContainerStyles,
        tablePreviewHeaderFont: '10px',
        admincardtitle: '12px',
        menutitle: '12px',
        dataEntryPageTitle: '14px',
        dataEntrysubtitle: '12px',
      }
    }
    if (isMd) {
      return {
        heading: '14px',
        subheading: '12px',
        title: '10px',
        subtitle: '9px',
        body: '1.25rem',
        cardIcons,
        loginButton,
        chip: chipText,
        datetitle: '8px',
        cardtitle: '11px',
        cardSubtitle: '10px',
        dataEntryPageTitle: '16px',
        dataEntrysubtitle: '12px',

        dashboardTittle: '13px',
        dashboardSubTittle: '16px',
        admintitle: '16px',
        adminsubtitle: '14px',
        goButton,
        headingStyles,
        paragraphStyles,
        previewHeading: '24px',
        typographyVariant: getTypographyVariant(),
        previewSubHeading: '16px',
        previewPageFont: '14px',
        previewText: '12px',
        tableContainerStyles,
        tablePreviewHeaderFont: '14px',
        admincardtitle: '12px',
        menutitle: '12px',
      }
    }
    if (isLg) {
      return {
        heading: '14px',
        subheading: '12px',
        title: '10px',
        subtitle: '9px',
        body: '1.375rem',
        cardIcons,
        loginButton,
        datetitle: '8px',
        cardtitle: '10px',
        timelinetitle: '14px',
        timelinetitlesubtitle: '13px',
        dashboardSubTittle: '13px',
        cardSubtitle: '9.5px',
        dataEntryPageTitle: '16px',
        dataEntrysubtitle: '12px',

        chip: chipText,
        dataEntryPageTittle,
        dashboardTittle: '14px',
        dashboardSubTittle: '16px',
        goButton,
        headingStyles,
        paragraphStyles,
        previewHeading: '24px',
        previewSubHeading: '16px',
        previewPageFont: '14px',
        typographyVariant: getTypographyVariant(),
        previewText: '12px',
        tableContainerStyles,
        tablePreviewHeaderFont: '14px',
        admintitle: '16px',
        adminsubtitle: '14px',
        admincardtitle: '12px',
        menutitle: '12px',
      }
    }
    if (isXl) {
      return {
        heading: '16px',
        subheading: '13px',
        title: '14px',
        subtitle: '13px',
        datetitle: '11px',
        cardtitle: '12px',
        timelinetitle: '14px',
        timelinetitlesubtitle: '13px',
        cardSubtitle: '10px',
        body: '1.5rem',
        cardIcons,
        loginButton,
        chip: chipText,
        dataEntryPageTittle,
        dashboardTittle: '16px',
        dashboardSubTittle: '14px',
        goButton,
        headingStyles,
        paragraphStyles,
        previewHeading: '24px',
        previewSubHeading: '16px',
        previewPageFont: '14px',
        typographyVariant: getTypographyVariant(),
        previewText: '12px',
        tableContainerStyles,
        tablePreviewHeaderFont: '14px',
        admintitle: '16px',
        adminsubtitle: '14px',
        admincardtitle: '12px',
        menutitle: '12px',
        dataEntryPageTitle: '16px',
        dataEntrysubtitle: '12px',
      }
    }
    // Default styles for other breakpoints
    return {
      title: '14px',
      subtitle: '1px',
      body: '1.25rem',
      cardIcons,
      loginButton,
      chip: chipText,
      dataEntryPageTittle,
      dashboardTittle: '16px',
      dashboardSubTittle: '16px',
      goButton,
      headingStyles,
      paragraphStyles,
      previewHeading: '24px',
      previewSubHeading: '16px',
      previewPageFont: '14px',
      typographyVariant: getTypographyVariant(),
      previewText: '12px',
      tableContainerStyles,
      tablePreviewHeaderFont: '14px',
      admintitle: '16px',
      adminsubtitle: '14px',
      menutitle: '12px',
      dataEntryPageTitle: '14px',
      dataEntrysubtitle: '12px',
    }
  }

  return getResponsiveTypography()
}
